type GasUsedFields = {
	computationCost?: string;
	storageCost?: string;
	storageRebate?: string;
	nonRefundableStorageFee?: string;
};

/**
 * Extract total gas used (base units) from a Sui transaction response.
 * Falls back to 0 if values are missing or unparsable.
 */
export function extractTotalGasUsed(response: any): number {
	try {
		const gas = (response as any)?.effects?.gasUsed as GasUsedFields | undefined;
		if (!gas) return 0;
		const computation = BigInt(gas.computationCost ?? 0);
		const storage = BigInt(gas.storageCost ?? 0);
		const rebate = BigInt(gas.storageRebate ?? 0);
		const nonRefundable = BigInt(gas.nonRefundableStorageFee ?? 0);
		const total = computation + storage + nonRefundable - rebate;
		const asNumber = total > 0n ? Number(total) : 0;
		return asNumber;
	} catch {
		return 0;
	}
}
